import { PriceBookItemTypes } from "@legacy/core/utils/enums"

import { ObjectsView } from "@organisms"

import { PRICEBOOK_ITEMS_ROUTES } from "@routes/pricebook-items"

export const ServicesTabs = () => (
    <ObjectsView.Tabs>
        <ObjectsView.Tab
            id="all_active"
            title="All Active"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.service],
                ["is_active", "true"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="review"
            title="Review"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.service],
                ["is_active", "true"],
                ["confirmed", "false"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="active"
            title="Active"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.service],
                ["is_active", "true"],
                ["confirmed", "true"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="all_inactive"
            title="All Inactive"
            phase="inactive"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.service],
                ["is_active", "false"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
    </ObjectsView.Tabs>
)

export const PartsAndMaterialsTabs = () => (
    <ObjectsView.Tabs>
        <ObjectsView.Tab
            id="all_active"
            title="All Active"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.part],
                ["is_active", "true"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="review"
            title="Review"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.part],
                ["is_active", "true"],
                ["confirmed", "false"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="active"
            title="Active"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.part],
                ["is_active", "true"],
                ["confirmed", "true"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="all_inactive"
            title="All Inactive"
            phase="inactive"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.part],
                ["is_active", "false"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
    </ObjectsView.Tabs>
)

export const MiscellaneousTabs = () => (
    <ObjectsView.Tabs>
        <ObjectsView.Tab
            id="all_active"
            title="All Active"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.other],
                ["is_active", "true"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="review"
            title="Review"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.other],
                ["is_active", "true"],
                ["confirmed", "false"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="active"
            title="Active"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.other],
                ["is_active", "true"],
                ["confirmed", "true"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="all_inactive"
            title="All Inactive"
            phase="inactive"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.other],
                ["is_active", "false"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
    </ObjectsView.Tabs>
)

export const DiscountsTabs = () => (
    <ObjectsView.Tabs>
        <ObjectsView.Tab
            id="all_active"
            title="All Active"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.discount],
                ["is_active", "true"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="review"
            title="Review"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.discount],
                ["is_active", "true"],
                ["confirmed", "false"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="active"
            title="Active"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.discount],
                ["is_active", "true"],
                ["confirmed", "true"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="all_inactive"
            title="All Inactive"
            phase="inactive"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.discount],
                ["is_active", "false"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
    </ObjectsView.Tabs>
)

export const TaxRatesTabs = () => (
    <ObjectsView.Tabs>
        <ObjectsView.Tab
            id="all_active"
            title="All Active"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.tax],
                ["is_active", "true"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="review"
            title="Review"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.tax],
                ["is_active", "true"],
                ["confirmed", "false"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="active"
            title="Active"
            phase="active"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.tax],
                ["is_active", "true"],
                ["confirmed", "true"],
                ["ordering", "description"],
            ]}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="all_inactive"
            title="All Inactive"
            phase="inactive"
            endpointKwargs={[
                ["pricebook_item_type", PriceBookItemTypes.tax],
                ["is_active", "false"],
                ["ordering", "confirmed,description"],
            ]}
            isDefaultActiveTabForPhase={true}
            listEndpoint={PRICEBOOK_ITEMS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={PRICEBOOK_ITEMS_ROUTES.COUNT}
        />
    </ObjectsView.Tabs>
)
